import { ResourceType } from '../types/resource.types'

/**
 * Valid resource types
 */
export const VALID_RESOURCE_TYPES = Object.values(ResourceType)

/**
 * Maximum resource title length
 */
export const MAX_RESOURCE_TITLE_LENGTH = 255

/**
 * Maximum resource description length
 */
export const MAX_RESOURCE_DESCRIPTION_LENGTH = 5000

/**
 * Maximum URL length
 */
export const MAX_URL_LENGTH = 2048

/**
 * URL validation regex (basic)
 */
export const URL_REGEX = /^https?:\/\/.+/i

/**
 * Valid video platforms
 */
export const VALID_VIDEO_PLATFORMS = ['youtube', 'vimeo', 'dailymotion', 'other'] as const

/**
 * Error messages
 */
export const RESOURCE_ERRORS = {
  NOT_FOUND: 'Ressource non trouvée',
  CHAPTER_NOT_FOUND: 'Chapitre non trouvé',
  LESSON_NOT_FOUND: 'Leçon non trouvée',
  INVALID_TYPE: 'Type de ressource invalide',
  INVALID_URL: 'URL invalide',
  INVALID_LINK: 'Les ressources doivent être liées à un chapitre ou une leçon',
  ACCESS_DENIED: 'Accès refusé à cette ressource',
  CREATION_FAILED: 'Erreur lors de la création de la ressource',
  UPDATE_FAILED: 'Erreur lors de la mise à jour de la ressource',
  DELETE_FAILED: 'Erreur lors de la suppression de la ressource',
} as const

export const RESOURCE_OPERATIONS = {
  CREATE: 'create_resource',
  FIND_ALL: 'findMany_resources',
  FIND_ONE: 'fetch_resource',
  UPDATE: 'update_resource',
  DELETE: 'delete_resource',
  SET_STATE: 'set_resource_state',
  SET_VISIBILITY: 'set_resource_visibility',
} as const

export const RESOURCE_LOG_MESSAGES = {
  CREATING: (userId: string, title: string) =>
    `[User ${userId}] Creating resource: ${title || 'Untitled'}`,
  CREATED: (id: string) => `Resource created successfully: ${id}`,
  UPDATING: (userId: string, id: string) => `[User ${userId}] Updating resource: ${id}`,
  UPDATED: (id: string) => `Resource updated successfully: ${id}`,
  UPDATED_WITH_LINKS: (id: string) => `Resource and links updated successfully: ${id}`,
  DELETING: (userId: string, id: string) => `[User ${userId}] Deleting resource: ${id}`,
  DELETED: (id: string) => `Resource soft deleted successfully: ${id}`,
  STATE_CHANGED: (id: string, state: string) => `Resource ${id} state changed to ${state}`,
  VISIBILITY_CHANGED: (id: string, visibility: string) =>
    `Resource ${id} visibility changed to ${visibility}`,
  FOUND: (count: number, userId: string) =>
    `Found ${count} resources for user ${userId}`,
  FOUND_PAGINATED: (count: number, total: number, userId: string) =>
    `Found ${count}/${total} resources for user ${userId} (cursor pagination)`,
} as const

export const RESOURCE_ERROR_CONTEXTS = {
  CREATE: 'create resource',
  FETCH_ALL: 'fetch resources',
  FETCH_PAGINATED: 'fetch paginated resources',
  FETCH_ONE: 'fetch resource',
  UPDATE: 'update resource',
  DELETE: 'delete resource',
  SET_STATE: 'set resource state',
  SET_VISIBILITY: 'set resource visibility',
  VALIDATE_LINKS: 'validate resource links',
} as const

export const RESOURCE_POLICY_ACTIONS = {
  CREATE: 'resource:create',
  VIEW: 'resource:view',
  UPDATE: 'resource:update',
  DELETE: 'resource:delete',
  SET_STATE: 'resource:setState',
  SET_VISIBILITY: 'resource:setVisibility',
} as const
